import l10n from '../../lang/locallang';

const {
    heading,
    image,
    labeledImage,
    list,
    paragraph,
    sortingActivity,
    statement,
    twoColumns,
    divider,
    accordion,
    table,
    imageText,
    timeline,
    gallery,
    flashCard,
    matching,
    sorting,
    choice,
    tabs,
    video
} = l10n.editor;

export const SettingsListByComponent = {
    'section_title': {
        'headingSection': heading,
        'imageSection': image,
        'labeledImageSection': labeledImage,
        'listSection': list,
        'paragraphSection': paragraph,
        'sortingActivitySection': sortingActivity,
        'statementSection': statement,
        'twoColumnsSection': twoColumns,
        'dividerSection': divider,
        'accordionSection': accordion,
        'tableSection': table,
        'imageTextSection': imageText,
        'timelineSection': timeline,
        'gallerySection': gallery,
        'flashcardSection': flashCard,
        'matchingSection': matching,
        'sortingSection': sorting,
        'choiceSection': choice,
        'videoSection': video,
        'tabsSection': tabs,
    },
    'layout_name': {
        'listUl': 'UL',
        'listOl': 'OL',
        'listCheckbox': 'Checkbox',
        'imageContainerWidth': 'Container',
        'imageFullWidth': 'Full Width',
        'imageLeftTextRight': 'Image Left',
        'imageRightTextLeft': 'Image Right',
        'imageTextFullWidth': 'Full Width',
        'gallery4': '4 in row',
        'gallery3': '3 in row',
        'gallery2': '2 in row',
        'statementA': 'Statement A',
        'statementB': 'Statement B',
        'statementC': 'Statement C',
        'statementNote': 'Note',
        'videoContainerWidth': 'Container',
        'videoFullWidth': 'Full Width',
    },
    'listSection': {
        'layouts': {
            0: 'listUl',
            1: 'listOl',
            2: 'listCheckbox',
        }
    },
    'paragraphSection': {
        // without settings for now
        // 'aiHelper' : {
        //     'type' : 'button-checkbox',
        //     'name' : 'ai-helper',
        //     'default' : false,
        //     'title' : 'Use AI helper',
        // }
    },
    'headingSection': {
        // without settings for now
    },
    'twoColumnsSection': {
        //deprecated for now
    },
    'accordionSection': {
        // without settings for now
    },
    'gallerySection': {
        'gallery': true,
        'layouts': {
            0: 'gallery4',
            1: 'gallery3',
            2: 'gallery2',
        }
    },
    'timelineSection': {
        // without settings for now
    },
    'imageSection': {
        'layouts': {
            0: 'imageContainerWidth', // 0 is the default layout
            1: 'imageFullWidth'
        },
        'image' : true,
        //'image-unsplash' : true,
        'image-text': true,
        'image-alt': true,
        'image-cut': true,
    },
    'labeledImageSection': {
        'image-labels': true,
        'image' : true,
        //'image-caption': true,
        'image-alt': true,
        'image-cut': true
    },
    'sortingActivitySection': {
        'sorting-activity': true,
    },
    'dividerSection': {
        // without settings for now
    },
    'statementSection': {
        'layouts': {
            0: 'statementA', // 0 is the default layout
            1: 'statementB',
            2: 'statementC',
            3: 'statementNote'
        }
    },
    'tabsSection': {
        // without settings for now
    },
    'imageTextSection': {
        'layouts': {
            0: 'imageLeftTextRight', // 0 is the default layout
            1: 'imageRightTextLeft',
            2: 'imageTextFullWidth',
        },
        'image' : true,
        'image-alt': true,
        'image-cut': true,
        'range-slider': {
            0: '10',
            1: '20',
            2: '30',
            3: '40',
            4: '50',
            5: '60',
            6: '70',
            7: '80',
            8: '90',
        }
    },
    'tableSection': {
        // without settings for now
    },
    'videoSection': {
        'layouts': {
            0: 'videoContainerWidth',
            1: 'videoFullWidth',
        },
        'video': true,
    }
}
